/**
 * @desc 更新已读
 */
const URL = "/rantion-crm";
import http, { updateResponse } from "@/http";
export function request(body: Array<number>, options?: any) {
  return updateResponse(
    http(URL + `/crm/ticket/read`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
